<template>
    <el-button icon="Delete" text
        :type="row.tpOrderId || row.slOrderId || row.tpAlgoId || row.slAlgoId ? 'primary' : 'info'"
        @click="cancelOrder()" :loading="loading" />
</template>

<script setup>
import { toRaw, ref } from "vue"
import { ElMessage } from 'element-plus'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'

const props = defineProps({
    row: Object
})
const systemStore = useSystemStore()
const logStore = useLogStore()
const loading = ref(false)

const cancelOrder = async () => {
    loading.value = true

    let orders = []
    let algoOrders = []

    if (props.row.tpOrderId) orders.push(props.row.tpOrderId)
    if (props.row.slOrderId) orders.push(props.row.slOrderId)
    if (props.row.tpAlgoId) algoOrders.push(props.row.tpAlgoId)
    if (props.row.slAlgoId) algoOrders.push(props.row.slAlgoId)

    if (!orders.length && !algoOrders.length) return
    try {


        orders.forEach(async (orderId) => {
            await systemStore.privateClient.cancelOrder(props.row.symbol, orderId)
        })

        algoOrders.forEach(async (algoId) => {
           await systemStore.privateClient.cancelAlgoOrder(algoId)
        })

        ElMessage.success('已撤销')
        loading.value = false
    } catch (error) {
        ElMessage.error('撤销失败' + error)
        loading.value = false
        logStore.addLog({
            title: '撤销订单失败',
            level: 'error',
            message: error
        })
    }
}
</script>